<ng-container *transloco="let t">
  {{ t(message) }}
</ng-container>
